module.exports = __webpack_public_path__ + "img/sfz1.7dc6e574.png";